/**
 * Site settings API – co-op-wide configuration (read public; write super-admin).
 */

import type {
  GetSiteSettingsResponse,
  UpdateSiteSettingsRequest,
} from '@lambda/shared/types';
import { apiRequest } from './apiClient';

export const siteSettingsApi = {
  get(accessToken?: string | null) {
    return apiRequest<GetSiteSettingsResponse>('/site-settings', accessToken ?? null, {
      method: 'GET',
    });
  },

  update(accessToken: string, data: UpdateSiteSettingsRequest) {
    return apiRequest<GetSiteSettingsResponse>('/site-settings', accessToken, {
      method: 'PUT',
      payload: data,
    });
  },

  boardPhotoUploadRequest(accessToken: string, fileType: string, fileSize: number) {
    return apiRequest<{ uploadUrl: string; fileKey: string; message?: string }>(
      '/site-settings/board-photo/upload-request',
      accessToken,
      {
        method: 'POST',
        payload: { fileType, fileSize },
      }
    );
  },

  boardPhotoConfirm(accessToken: string) {
    return apiRequest<GetSiteSettingsResponse>('/site-settings/board-photo/confirm', accessToken, {
      method: 'POST',
      payload: {},
    });
  },

  boardPhotoRemove(accessToken: string) {
    return apiRequest<GetSiteSettingsResponse>('/site-settings/board-photo', accessToken, {
      method: 'DELETE',
    });
  },
};
